import { ActivityReportInterface, BudgetReportInterface, ObjectiveReportInterface, ProgressReportPreviewInterface } from "@/src/models/IProgress";
import { Button, Card, Flex, Form, List, Modal, Radio, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import CkEditor from "../ckeditor/ckEditor";
import { Editor } from "ckeditor5";
import moment from "moment";
import { formatNumber, monthcolumn } from "../functionLater";
import axios from "axios";
import { AboutResearchInterface } from "@/src/models/IAboutResearch";
import { BudgetDataInterface, UsedBudgetInterface } from "@/src/models/IBudgetData";
import { OutputFileListInterface, OutputInterface, OutputReportInterface } from "@/src/models/Result";
import { useNavigate, useParams } from "react-router-dom";
require('moment/locale/th');

moment.locale('th');

export function CompletionReportStaffReview(){

    const { progress_id } = useParams();

    const navigate = useNavigate();


    const [reviewForm] = Form.useForm();

    const [IsStudent,setIsStudent] = useState(true)

    const [isActive,setisActive]= useState(true);
    const [Keys, setExpandedRowKeys] = useState<string[]>([]);

    const [SentedData,setSentedData]= useState<ProgressReportPreviewInterface>();
    const [IsReview,setIsReview] = useState(true)
    const [CurrentReviewer,setCurrentReviewer] = useState('')

    const [LastComment,setPreviousLastComment] = useState('')
    const [PreviouseComment,setPreviouseComment] = useState('')
    const [SubmitDate,setSubmitDate] = useState(moment())
    const PreviouseCommentRef = useRef<Editor | null>(null);


    const [Output,setOutput] = useState<OutputInterface[]>([])
    const [OutputProgress,setOutputProgress] = useState<OutputReportInterface[]>([])
    const [OutputFileList,setOutputFileList] = useState<OutputFileListInterface[]>([])
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    const [SubmitMod,setSubmitMod] = useState(false);

    const [selectedmonth,setselectedmonth] = useState(99)
    const [endmonth,setEndMonth] = useState(99)
    const [selectedyear,setselectedyear] = useState(9999)
    
    const {ROCKEditors,CKEditors,getHTML} = CkEditor();

    const [DataFirst,setDataFirst] = useState<AboutResearchInterface[]>([]);


    const ProgressSummaryRef = useRef<Editor | null>(null);
    const ProblemsAndObstacleRef = useRef<Editor | null>(null);
    const SuggestionRef = useRef<Editor | null>(null);
    const FuturePlanRef = useRef<Editor | null>(null);

   

    const [ActivityReport,setActivityReport] = useState<ActivityReportInterface[]>([]);
    const [CompensationBudgetReport,setCompensationBudgetReport] = useState<BudgetReportInterface[]>([]);
    const [OutcomeBudgetReport,setOutcomeBudgetReport] = useState<BudgetReportInterface[]>([]);
    const [ItemExpenseBudgetReport,setItemExpenseBudgetReport] = useState<BudgetReportInterface[]>([]);
    const [ObjectiveReport,setObjectiveReport] = useState<ObjectiveReportInterface[]>([]);
    const [OutputReport,setOutputReport] = useState<OutputReportInterface[]>([]);



    const [compensationItems, setCompensationItems] = useState<BudgetDataInterface[]>([]);
    const [compensationUsedBudget,setCompensationUsedBudget] = useState<UsedBudgetInterface[]>([]);
    const [OutcomeItems, setOutcomeItems] = useState<BudgetDataInterface[]>([]);
    const [OutcomeUsedBudget,setOutcomeUsedBudget] = useState<UsedBudgetInterface[]>([]);
    const [ItemCost, setItemCost] = useState<BudgetDataInterface[]>([]);
    const [itemUsedBudget,setitemUsedBudget] = useState<UsedBudgetInterface[]>([]);

    const [compensationsum,setCompensationSum] = useState(0)
    
    const [compensationMonetry,setCompensationMonetrySum] = useState(0)
    const [compensationPrepared,setCompensationPreparedSum] = useState(0)
    const [compensationIndirect,setCompensationIndirectSum] = useState(0)

    const [outcomesum,setOutcomeSum] = useState(0)
    const [outcomeMonetry,setOutcomeMonetrySum] = useState(0)
    const [outcomePrepared,setOutcomePreparedSum] = useState(0)
    const [outcomeIndirect,setOutcomeIndirectSum] = useState(0)

    const [itemsum,setItemnSum] = useState(0)
    const [itemMonetry,setItemMonetrySum] = useState(0)
    const [itemPrepared,setItemPreparedSum] = useState(0)
    const [itemIndirect,setItemIndirectSum] = useState(0)
  
    const compensationUsedSum = CompensationBudgetReport.reduce((total, item) => total + Number(item.Spent || 0), 0);
    const outcomeUsedSum = OutcomeBudgetReport.reduce((total, item) => total + Number(item.Spent || 0), 0);
    const itemExpenseUsedSum = ItemExpenseBudgetReport.reduce((total, item) => total + Number(item.Spent || 0), 0);


    const BudgetTypeCol = [
        {
          id: 1,
          detail: 'หมวดค่าตอบแทน',
          category:'compensation',
          sum:compensationsum,
          Usedsum:compensationUsedSum,
          MonetrySum:compensationMonetry,
          PreparedSum:compensationPrepared,
          IndirectSum:compensationIndirect
        },
        {
          id: 2,
          detail: 'หมวดค่าใช้จ่าย',
          category:'outcome',
          sum:outcomesum,
          Usedsum:outcomeUsedSum,
          MonetrySum:outcomeMonetry,
          PreparedSum:outcomePrepared,
          IndirectSum:outcomeIndirect
        },
        {
            id: 3,
            detail: 'หมวดค่าวัสดุ และอุปกรณ์',
            category:'itemexpense',
            sum:itemsum,
            Usedsum:itemExpenseUsedSum,
            MonetrySum:itemMonetry,
            PreparedSum:itemPrepared,
            IndirectSum:itemIndirect
          },
          {
            id: 4,
            detail: 'รวม',
            category:'',
            sum:Number(itemsum)+Number(outcomesum)+Number(compensationsum),
            Usedsum:compensationUsedSum + outcomeUsedSum + itemExpenseUsedSum,
            MonetrySum:Number(compensationMonetry)+Number(outcomeMonetry)+Number(itemMonetry),
            PreparedSum:Number(compensationPrepared)+Number(outcomePrepared)+Number(itemPrepared),
            IndirectSum:Number(compensationIndirect)+Number(outcomeIndirect)+Number(itemIndirect)
          }
      ];

    const getData = async() =>{
        await axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${sessionStorage.getItem('project_id')}/${sessionStorage.getItem('user')}`).then(response=>{
            setDataFirst(response.data.main)

            if(response.data.main[0].budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
                setIsStudent(false)
              }


            if(response.data.main[0].period){
                const dataperiod = JSON.parse(response.data.main[0].period)
                const datamonth = dataperiod[0].split('-')
                const datamonth2 = dataperiod[1].split('-')
                setselectedmonth(Number(datamonth[1]))
                setEndMonth(Number(datamonth2[1]))
                setselectedyear(Number(datamonth[0]))
            }

            if(response.data.compensation.length!=0||response.data.outcome.length!=0||response.data.itemexpense.length!=0){
                setCompensationItems(response.data.compensation)
                setCompensationUsedBudget(response.data.compensation)
                const totalCompensation = response.data.compensation.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setCompensationSum(totalCompensation)
                const totalMonetryCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationMonetrySum(totalMonetryCompensationBudget)
                const totalPreparedCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationPreparedSum(totalPreparedCompensationBudget)
                const totalIndirectCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationIndirectSum(totalIndirectCompensationBudget)
            
                const totalOutcome = response.data.outcome.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setOutcomeSum(totalOutcome)
                setOutcomeItems(response.data.outcome)
                setOutcomeUsedBudget(response.data.outcome)
                const totalMonetryOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeMonetrySum(totalMonetryOutcomeBudget)
                const totalPreparedOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomePreparedSum(totalPreparedOutcomeBudget)
                const totalIndirectdOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeIndirectSum(totalIndirectdOutcomeBudget)

                const totalItem = response.data.itemexpense.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setItemnSum(totalItem)
                setItemCost(response.data.itemexpense)
                setitemUsedBudget(response.data.itemexpense)
                const totalMonetryItemBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemMonetrySum(totalMonetryItemBudget)
                const totalPreparedItemeBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemPreparedSum(totalPreparedItemeBudget)
                const itemMonetrySum = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemIndirectSum(itemMonetrySum)
                
            }
            if(response.data.main[0].output&&response.data.main[0].outcome&&response.data.main[0].impacts){
                setOutput(JSON.parse(response.data.main[0].output))
                setOutputProgress(JSON.parse(response.data.main[0].output))
              }
              setisActive(false)
        })
  }

  const GetReport = async()=>{
    await axios.get(`${process.env.REACT_APP_BASE}/GetProgressData/${progress_id}/${sessionStorage.getItem('head_user')}`).then(async response=>{
        if(response.status==200){
            setCurrentReviewer(sessionStorage.getItem("PositionName")||'')
            setSentedData(response.data.main[0])
            setActivityReport(response.data.activity)
            setCompensationBudgetReport(response.data.compensationbudget)
            setOutcomeBudgetReport(response.data.outcomebudget)
            setItemExpenseBudgetReport(response.data.itemexpensebudget)
            setObjectiveReport(response.data.obj)
            console.log(response.data.output)
            console.log(response.data.main[0])

            setOutputReport(response.data.output)

            if(sessionStorage.getItem('PositionName')=='เจ้าหน้าที่')
            {
                if(response.data.main[0].ReportStatus!='รอการพิจารณาจากเจ้าหน้าที่วิจัย'){
                setIsReview(false)
                await axios.get(`${process.env.REACT_APP_BASE}/getOwnCompleteReportReview/${progress_id}/${sessionStorage.getItem('user')}`).then(resp=>{
                    if(resp.status==200){
                        setPreviousLastComment(resp.data.ApprovedStatus)
                        setPreviouseComment(resp.data.note)
                        setSubmitDate(resp.data.SummittedDate)
                    }
                })
            }}else if(sessionStorage.getItem('PositionName')=='ผู้อำนวยการสำนักวิจัยและบริการวิชาการ'){
                if(response.data.main[0].ReportStatus!='รอการพิจารณาจากผู้อำนวยการสำนักวิจัย'){
                    setIsReview(false)
                    await axios.get(`${process.env.REACT_APP_BASE}/getOwnCompleteReportReview/${progress_id}/${sessionStorage.getItem('user')}`).then(resp=>{
                        if(resp.status==200){
                            setPreviousLastComment(resp.data.ApprovedStatus)
                            setPreviouseComment(resp.data.note)
                            setSubmitDate(resp.data.SummittedDate)
                        }
                    })
                }
            }else if(sessionStorage.getItem('PositionName')=='รองอธิการบดีฝ่ายวิจัยและบริการวิชาการ'){
                if(response.data.main[0].ReportStatus!='รอการพิจารณาจากรองอธิการบดีสำนักฝ่ายวิจัยฯ'){
                    setIsReview(false)
                    await axios.get(`${process.env.REACT_APP_BASE}/getOwnCompleteReportReview/${progress_id}/${sessionStorage.getItem('user')}`).then(resp=>{
                        if(resp.status==200){
                            setPreviousLastComment(resp.data.ApprovedStatus)
                            setPreviouseComment(resp.data.note)
                            setSubmitDate(resp.data.SummittedDate)
                        }
                    })
                }

            }
        }
        })
    }
    const [OutputMod,setOutputMod] = useState(false);
    const [OutputShow,setOutputShow] = useState(false);
    const [OutputTopic,setOutputTopic]= useState('');

    const getFilelist = async(Output:any) =>{
        const data = {
            Output : Output
        }
        console.log(data)
       

        axios.post(`${process.env.REACT_APP_BASE}/getOutputFileList/${sessionStorage.getItem('project_id')}/${SentedData?.ProgressReportID}`,data).then(response=>{
            if(response.status==200){
                setOutputFileList(response.data)
                setOutputTopic(Output)
                setOutputMod(true)
            }
        })
    }

    const viewFile = async(Output:any,FileID:number)=>{
        const data = {
            Output:Output,
        }
        await axios.post(`${process.env.REACT_APP_BASE}/GetOutputFile/${FileID}`,data,
        { responseType: 'blob' }).then(response=>{
            if (response.status === 200) {

                const blob = response.data; 
                const blobUrl = URL.createObjectURL(blob);
    
                setPreviewUrl(blobUrl); 
            }
        })

    }
    const handleExpand = (expanded: boolean, record: any) => {
        setisActive(true)
        if (expanded) {
            console.log(record.id)
            setExpandedRowKeys([record.id]); 
            setisActive(false)

        } else {
            setExpandedRowKeys([]); // Collapse all rows
            setisActive(false)
        }
    };

    const handlesubmit = async() =>{
        const ReviewData = reviewForm.getFieldsValue();
        const data = {
            ApprovedStatus:ReviewData.ApprovedStatus,
            note:ReviewData.note,
            Approver:sessionStorage.getItem('user'),
            ApproverName:sessionStorage.getItem('fullname'),
            ApproverPosition:sessionStorage.getItem('PositionName'),
            CompletionStatus:"Completed",
        }

        await axios.post(`${process.env.REACT_APP_BASE}/setCompletionReview/${progress_id}`,data).then(response=>{
            if(response.status=200){
                navigate('/VRIIS/ProgressReportList')
            }
        })
    }

    useEffect(() =>{
        getData();
        GetReport();
        },[])

        const expandedRowRender = (tempdata: any) => {
            let dataSource:  any[] = [];
      
            const category = tempdata.category
      
            if (tempdata.category === 'compensation') {
              dataSource = CompensationBudgetReport;
            } else if (tempdata.category === 'outcome') {
              dataSource = OutcomeBudgetReport;
            } else if (tempdata.category === 'itemexpense') {
              dataSource = ItemExpenseBudgetReport;
            }
          
            return <>
              <Table
                  columns={[
                      {
                          title:'',
                          dataIndex: 'BudgetDetail',
                          key: 'BudgetDetail',
                          width: 450,
                        render: (_, record,index) => (
                            <>
                                <p>{record.BudgetDetail} </p>
                                {typeof dataSource[index]?.note === 'string' && (
                                    <p style={{ color: 'gray' }}>{dataSource[index].note}</p>
                                )}
                            </>
                        ),
                      },
                      {
                          title:'',
                          dataIndex: 'Budget',
                          key: 'Budget',
                          width: 250,
                          render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.Budget)}</Flex>
                          ),},
                      {
                          title:'',
                          dataIndex: 'Spent',
                          key: 'Spent',
                          width: 250,
                          render: (_, record) => (
                            <Flex justify="center">{formatNumber(record.Spent)}</Flex>
                            ),
                      },
                      {
                        title:'',
                        dataIndex: 'note',
                      }
                  ]}
                  showHeader={false} 
                  pagination={false}
                  dataSource={dataSource}/>
            </>
          }
    

    return(<>
        <h1  className="text-3xl font-semibold ">รายงานขอปิดโครงการ</h1>
        <br/>
        <hr/>
        <br/>
        <p><span style={{fontWeight:'bold'}}>ชื่อโครงการ:</span>&nbsp;{DataFirst[0]?.project_name_th}&nbsp;({DataFirst[0]?.project_name_en})&nbsp;<span style={{fontWeight:'bold'}}>โดย</span>&nbsp;{SentedData?.head_name_th}</p>
        <br/>
        <p style={{fontWeight:'bold'}}>แผนการการดำเนินงานและความสำเร็จต่อโครงการ</p>
        <Table
        columns={[
            {
              title:'แผนการการดำเนินงาน',
              dataIndex:'ActivityName',
              fixed: 'left',  
              width: 200,  
              className: 'fixed-column'
            },
            {
              title:'ระยะเวลาที่ทำกิจกรรม',
              children:monthcolumn(selectedmonth,endmonth,DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [])
            },{
              title:'ความสำเร็จต่อโครงการ',
              fixed: 'right',  
              className: 'fixed-column',
              render: (_, record,index) =>(
                <>
                    <Flex justify='center'>
                        100 %
                    </Flex>
                </>
              )
            },{
              title:'หมายเหตุ',
              fixed: 'right',  
              width: 200, 
              className: 'fixed-column',
              render: (_, record,index) =>(
                <>
                    <Flex justify='center'>
                        {ActivityReport[index]?.note}
                    </Flex>
                </>
              )
            }
        ]}
        scroll={{ x: 'max-content' }}
        pagination={false}
        dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
        />
    <br/>
    {IsStudent&&
    <div>
        <p className="font-bold leading-relaxed" >รายละเอียดของขั้นตอนการดำเนินงานจริงตามแผนงาน (ช่วงรายงานผล) </p>
        <Table
            columns={[
                {
                    title:'วัตถุประสงค์', 
                    dataIndex:'ActivityName',
                    width:'30vw'
                },
                {
                    title:'สิ่งที่ดำเนินการแล้วระยะ 6 เดือน',
                    dataIndex:'SixMonthProgress',
                    width:'40vw',
                    render: (_, record,index) =>(
                        <>
                            <p dangerouslySetInnerHTML={{ 
                                __html: (record?.SixMonthProgress )
                            }}/>
                        </>
                    )
                    
                },
            ]}
            pagination={false}
            dataSource={ObjectiveReport}
            />
        <br/>
        
    <p className="font-semibold">สรุปผลการดำเนินงาน</p>
    <ROCKEditors 
        myRef={ProgressSummaryRef}
        htmlBox={SentedData?.ProgressionSummary}
        />
    <p className="font-semibold">ปัญหาและอุปสรรค</p>
    <ROCKEditors
        myRef={ProblemsAndObstacleRef}
        htmlBox={SentedData?.ProblemAndObstacle}/>
    <p className="font-semibold">คำแนะนำและข้อมูลเพิ่มเติมอื่นๆ (ถ้ามี) </p>
    <ROCKEditors
        myRef={SuggestionRef}
        htmlBox={SentedData?.SuggestionAndInformation}/>
    <br/>
    <p className="font-semibold">รายจ่ายที่เกิดขึ้นจริง รอบ 6 เดือน</p>
    <Table
        rowKey="id"
        columns={[
            {
                title:'หมวดรายการงบประมาณ',
                dataIndex:'detail',
                width: 450,
            },
            {
                title:'งบประมาณ (บาท)',
                width: 500,
                children:[
                    {
                        title:'งบประมาณที่ได้รับ',
                        width: 250,
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.MonetrySum+record.PreparedSum+record.IndirectSum)}</Flex>
                        ),},
                    {
                        title:'จำนวนเงินที่ใช้ไป',
                        width: 250,
                        render: (_, record) => (
                          <>
                            <Flex justify="center">
                                <p>{formatNumber(record.Usedsum)}</p>
                            </Flex>
                          </>
                    )},
                ]
            },
            {
                title:'หมายเหตุ',
                render: (_, record) => (
                    <>
                      <Flex justify="center">
                        <p>-</p>
                      </Flex>
                    </>
              )
            },
        ]}
        expandable={{
            expandedRowRender,
            expandedRowKeys: Keys,
            onExpand: handleExpand,
            rowExpandable: (record) => {
                if (record.category === 'compensation') return compensationItems.length > 0;
                if (record.category === 'outcome') return OutcomeItems.length > 0;
                if (record.category === 'itemexpense') return ItemCost.length > 0;
                return false;
              },
        }}
        scroll={{ x: 'max-content' }}
        dataSource={BudgetTypeCol}
        pagination={false}
        />
    <br/>
    </div>}
    
    <p className="font-semibold">ผลผลิตที่คาดว่าจะได้รับ</p>
    <Table
        columns={[
            {
                title:'ผลผลิต',
                dataIndex:'Output_name',
                fixed: 'left',  
                width: 200,  
                className: 'fixed-column'
            },{
                title: 'จำนวนนำส่ง/หน่วยนับ',
                dataIndex:'Output_amount',
                key: 'Output_amount',
            },{
                title:'รายละเอียดผลผลิต',
                dataIndex:'Output_description',
                key: 'Output_description',
            },{
                title:'ปีที่นำส่งผลผลิต',
                dataIndex:'SentYear',
                key: 'SentYear',
                render: (_, record) => (
                    <>
                        <Flex justify='center'>
                            <p>{moment(record?.SentYear)?.format('YYYY')}</p>
                        </Flex>
                    </>
                  ), 
            },{
                title:'เปอร์เซ็นความก้าวหน้าการดำเนินงาน',
                dataIndex:'Progresspercentage',
                key: 'Progresspercentage',
                render: (_, record) => (
                    <>
                        <Flex justify='center'>
                            <p>100 %</p>
                        </Flex>
                    </>
                  ), 
            },{
                title:'ผลผลิตที่เกิดขึ้นจริง',
                dataIndex:'RealOutput',
                key: 'RealOutput',
            },{
                title:'หลักฐาน/เอกสารประกอบ',
                dataIndex:'Attachment',
                key: 'Attachment',
                render: (_, record) => (
                    <>
                        <p dangerouslySetInnerHTML={{ 
                            __html: (record?.Attachment)
                        }}/>
                    </>
                  ), 
            },{
                title:'ไฟล์แนบ',
                width: 200,
                render: (_, record) => (
                    <>
                        <Flex justify='center'>
                            <Button 
                            onClick={()=>{
                                getFilelist(record.Output_name)
                            }}>ดูข้อมูลไฟล์ที่อัพโหลด</Button>
                        </Flex>
                    </>
                  ), 
            }
        ]}
        scroll={{ x: 'max-content' }}
        pagination={false}
        dataSource={OutputReport}
        />
         <Modal
            title={`รายชื่อไฟล์ที่เพิ่มเข้ามาในระบบ : ${OutputTopic}`}
            open={OutputMod}
            onCancel={()=>{setOutputMod(false)
                setPreviewUrl(null)}}
            footer={<></>}
            >
                <List
                            bordered
                            renderItem={(item, index) =>(
                                <><List.Item
                                    actions={[
                                        <> 
                                            <a onClick={()=>viewFile(item.Output,item.FileID)}>ดูไฟล์</a>
                                        </>
                                    ]}>
                                    <List.Item.Meta
                                        title={<p>{item.Filename}</p>}
                                    />
                                </List.Item>
                                    <br/>
                                
                                </>
                            )}
                            dataSource={OutputFileList}/>
                            <br/>
                {previewUrl&&<>
                    <iframe src={previewUrl} 
                        width="100%"
                        height="600px"
                        title="PDF Viewer"/>
                </>}
            </Modal>
        <br/>
        <p style={{fontWeight:'bold'}}>ผู้รับทุนยื่นขอปิดโครงการวิจัยภายใต้เงื่อนไขดังนี้</p>
        <Card>
            <p>{SentedData?.CompletionPassingMeasure}</p>
            <p style={{marginLeft:'5vw'}}>{SentedData?.SubCompletionPassingMeasure}</p>
        </Card>
        <br/>

        <h1 className="text-3xl font-semibold ">ผลการอนุมัติโครงการ</h1>
        {
            IsReview&&
            <>
                {CurrentReviewer=='เจ้าหน้าที่'&&<>
                    <Card>
                        <Form form={reviewForm}>
                            <Form.Item label='ผลการอนุมัติ' name={'ApprovedStatus'}>
                                <Radio.Group>
                                    <Radio value={'รอการพิจารณาจากผู้อำนวยการสำนักวิจัย'}>
                                        ยื่นต่อผู้อำนวยการสำนักวิจัย
                                    </Radio>
                                    <Radio value={'มีข้อแก้ไข'}>
                                        มีข้อแก้ไข
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item label='บันทึกข้อความ' name={'note'}>
                                <CKEditors/>
                            </Form.Item>
                            <Flex justify='center'><Button onClick={()=>setSubmitMod(true)}>ยื่นอนุมัติโครงการ</Button></Flex>
                            <Modal
                                centered
                                footer={<></>}
                                onCancel={()=>setSubmitMod(false)}
                                open={SubmitMod}>
                                <p>ท่านต้องการยื่นผลการอนุมัติของท่านเข้าสู่ระบบหรือไม่</p>
                                <br/>
                                <Flex justify='flex-end'>
                                    <Button type='primary' danger onClick={()=>setSubmitMod(false)}>ยกเลิก</Button>&nbsp;
                                    <Button type='primary' onClick={()=>handlesubmit()} >ยืนยัน</Button>
                                </Flex>
                            </Modal>
                        </Form>
                        
                    </Card>
                </>}
                {CurrentReviewer=='ผู้อำนวยการสำนักวิจัยและบริการวิชาการ'&&<>
                    <Card>
                        <Form form={reviewForm}>
                            <Form.Item label='ผลการอนุมัติ' name={'ApprovedStatus'}>
                                <Radio.Group>
                                    <Radio value={'รอการพิจารณาจากรองอธิการบดีสำนักฝ่ายวิจัยฯ'}>
                                        ยื่นต่อรองอธิการบดีสำนักฝ่ายวิจัยฯ
                                    </Radio>
                                    <Radio value={'มีข้อแก้ไข'}>
                                        มีข้อแก้ไข
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item label='บันทึกข้อความ' name={'note'}>
                                <CKEditors/>
                            </Form.Item>
                            <Flex justify='center'><Button onClick={()=>setSubmitMod(true)}>ยื่นอนุมัติโครงการ</Button></Flex>
                            <Modal
                                centered
                                footer={<></>}
                                onCancel={()=>setSubmitMod(false)}
                                open={SubmitMod}>
                                <p>ท่านต้องการยื่นผลการอนุมัติของท่านเข้าสู่ระบบหรือไม่</p>
                                <br/>
                                <Flex justify='flex-end'>
                                    <Button type='primary' danger onClick={()=>setSubmitMod(false)}>ยกเลิก</Button>&nbsp;
                                    <Button type='primary' onClick={()=>handlesubmit()} >ยืนยัน</Button>
                                </Flex>
                            </Modal>
                        </Form>
                        
                    </Card></>}
                {CurrentReviewer=='รองอธิการบดีฝ่ายวิจัยและบริการวิชาการ'&&<>
                    <Card>
                        <Form form={reviewForm}>
                            <Form.Item label='ผลการอนุมัติ' name={'ApprovedStatus'}>
                                <Radio.Group>
                                    <Radio value={'อนุมัติ'}>
                                    อนุมัติ
                                    </Radio>
                                    <Radio value={'มีข้อแก้ไข'}>
                                        มีข้อแก้ไข
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item label='บันทึกข้อความ' name={'note'}>
                                <CKEditors/>
                            </Form.Item>
                            <Flex justify='center'><Button onClick={()=>setSubmitMod(true)}>ยื่นอนุมัติโครงการ</Button></Flex>
                            <Modal
                                centered
                                footer={<></>}
                                onCancel={()=>setSubmitMod(false)}
                                open={SubmitMod}>
                                <p>ท่านต้องการยื่นผลการอนุมัติของท่านเข้าสู่ระบบหรือไม่</p>
                                <br/>
                                <Flex justify='flex-end'>
                                    <Button type='primary' danger onClick={()=>setSubmitMod(false)}>ยกเลิก</Button>&nbsp;
                                    <Button type='primary' onClick={()=>handlesubmit()} >ยืนยัน</Button>
                                </Flex>
                            </Modal>
                        </Form>
                        
                    </Card></>}
            </>||<>
                <Card>
                    {CurrentReviewer=='เจ้าหน้าที่'&&<p>ผลการอนุมัติ : {LastComment=='รอการพิจารณาจากผู้อำนวยการสำนักวิจัย'&&<span>ยื่นต่อผู้อำนวยการสำนักวิจัย</span>||<span>{LastComment}</span>}</p>}
                    {CurrentReviewer=='ผู้อำนวยการสำนักวิจัยและบริการวิชาการ'&&<p>ผลการอนุมัติ : {LastComment=='รอการพิจารณาจากรองอธิการบดีสำนักฝ่ายวิจัยฯ'&&<span>ยื่นต่อรองอธิการบดีสำนักฝ่ายวิจัยฯ</span>||<span>{LastComment}</span>}</p>}
                    {CurrentReviewer=='รองอธิการบดีฝ่ายวิจัยและบริการวิชาการ'&&<p>ผลการอนุมัติ : {LastComment}</p>}
                    <p>บันทึกข้อความ :</p>
                    <ROCKEditors
                        myRef={PreviouseCommentRef}
                        htmlBox={PreviouseComment}/>
                    <p><span >ลงความเห็นเมื่อ</span> {moment.utc(SubmitDate).format('DD MMMM YYYY hh:mm:ss')} น.</p>
                    <Flex justify='center'>
                        <Button type='primary' href={`${process.env.REACT_APP_BASE}/exportProgressRep/project_id/${sessionStorage.getItem('head_user')}`}>ดาวน์โหลดไฟล์</Button>
                    </Flex>
                </Card>
            </>
        }
    </>)
}